import * as Scrivito from "scrivito";

import ImageOrVideo from "../ImageOrVideo";

function PageHeadBlock({ page }) {
  const hasMedia = page.get("image");
  const mediaClass = hasMedia ? "col-12 col-lg-5" : "";
  const contentClass = hasMedia ? "col-12 col-lg-7" : "col-12";

  return (
    <>
      <div className="page-header-widget bg-blue">
        <div className="container">
          <div className="row">
            {hasMedia && (
              <div className={`${mediaClass} position-relative`}>
                <div className="page-header-widget__media">
                  <ImageOrVideo
                    widget={page}
                    className="page-header-widget__image img-fluid"
                  />
                </div>
              </div>
            )}
            <div className={contentClass}>
              {page.get("shortTitle") ? (
                <Scrivito.ContentTag
                  tag="h1"
                  className="page-header-widget__headline"
                  content={page}
                  attribute="shortTitle"
                />
              ) : (
                <Scrivito.ContentTag
                  tag="h1"
                  className="page-header-widget__headline"
                  content={page}
                  attribute="title"
                />
              )}
              <Scrivito.ContentTag
                className="page-header-widget__description"
                content={page}
                attribute="description"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container pt-0">
        <div className="breadcrumb-wrapper --page-mode" />
      </div>
    </>
  );
}

export default Scrivito.connect(PageHeadBlock);
